import { Routes } from '@angular/router';
import { OrganisationsComponent } from './organisations/organisations.component';
import { DesktopComponent } from './dashboard/desktop.component';
import { ResourceTypesComponent } from './resourcetypes/resourcetypes.component';
import { SchedulesComponent } from './schedules/schedules.component';
import { ResourcesComponent } from './resources/resources.component';
import { ResourceAvailabilityComponent } from './resources/resource-availability/resource-availability.component';
import { ConstraintsComponent } from './schedules/constraints/constraints.component';
import { LoginComponent } from './login/login.component';
import { SsoCallbackComponent } from './sso-callback/sso-callback.component';
import { authGuard } from './guards/auth.guard';
import { ssoGuard } from './guards/sso.guard';

// Import the real ResourceAttributesComponent
import { ResourceAttributesComponent } from './resourceattributes/resourceattributes.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'sso-callback', component: SsoCallbackComponent },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: 'dashboard', component: DesktopComponent, canActivate: [ssoGuard, authGuard] },
  { path: 'organisations', component: OrganisationsComponent, canActivate: [ssoGuard, authGuard] },
  { path: 'resourcetypes', component: ResourceTypesComponent, canActivate: [ssoGuard, authGuard] },
  { path: 'resources', component: ResourcesComponent, canActivate: [ssoGuard, authGuard] },
  { path: 'resourceattributes/:organisationId/:resourceTypeId', component: ResourceAttributesComponent, canActivate: [ssoGuard, authGuard] },
  { path: 'resources/:resourceTypeId/:resourceId/availability', component: ResourceAvailabilityComponent, canActivate: [ssoGuard, authGuard] },
  { path: 'schedules', component: SchedulesComponent, canActivate: [ssoGuard, authGuard] },
  { path: 'schedules/:scheduleId/constraints', component: ConstraintsComponent, canActivate: [ssoGuard, authGuard] },
];
